const locale = {
  blocker: {
    adult: {
      cta: "Saya Sudah Dewasa",
      signInCta: "Masuk",
      subtitle: "Video ini berisi konten yang tidak sesuai untuk remaja dan anak-anak.",
      title: "Konten dewasa dan sensitif"
    },
    chrome_version: {
      subtitle: "Pastikan kamu menggunakan Google Chrome versi terbaru.",
      title: "Update browser-mu dulu, ya"
    },
    drm: {
      additional_cta: "Info Lengkap",
      cta: "Cari konten lain",
      subtitle: "Coba lagi dengan perangkat yang mendukung atau cari hiburan lain di Vidio, yuk.",
      title: "Perangkatmu nggak mendukung DRM"
    },
    fetching_error: {
      additional_cta: "Laporkan Masalah",
      cta: "Coba Lagi",
      subtitle: "Tunggu selagi kami mengatasinya dan coba lagi nanti, ya!",
      title: "Terjadi gangguan nih"
    },
    general_error: {
      additional_cta: "Laporkan Masalah",
      cta: "Coba Lagi",
      subtitle: "Tunggu selagi kami mengatasinya dan coba lagi nanti, ya!",
      title: "Terjadi gangguan nih"
    },
    geoblock: {
      additional_cta: "Info Lengkap",
      cta: "Jelajahi Vidio",
      subtitle: "Masih banyak konten menarik lainnya yang bisa kamu nikmati di Vidio, lho!",
      title: "Konten tidak tersedia di negara kamu"
    },
    hdcp: {
      additional_cta: "Info Lengkap",
      cta: "Jelajahi Vidio",
      subtitle: "Perangkatmu nggak mendukung HDCP. Gunakan perangkat lain atau cari hiburan lain.",
      title: "Konten nggak bisa diputar"
    },
    media_error: {
      additional_cta: "Detail Error",
      cta: "Laporkan Masalah",
      subtitle: "Silakan coba lagi dengan perangkat lain",
      title: "Terjadi kesalahan saat memproses media"
    },
    media_not_supported: {
      additional_cta: "Detail Error",
      cta: "Laporkan Masalah",
      subtitle: "Silakan coba lagi dengan perangkat lain.",
      title: "Terdapat kendala pada perangkatmu"
    },
    network_error: {
      additional_cta: "Detail Error",
      cta: "Coba Lagi",
      subtitle: "Ada kendala saat terhubung ke Vidio. Coba lagi nanti, ya.",
      title: "Masalah pada jaringan"
    },
    not_supported_browser: {
      additional_cta: "Laporkan Masalah",
      subtitle: "Silakan perbarui browsermu, atau download aplikasi Vidio.",
      title: "Perangkatmu nggak mendukung."
    },
    sign_in: {
      cta: "Sign In",
      description: "Sign in untuk menonton video ini"
    }
  },
  control_bar: {
    "Cinema Mode": "Cinema Mode (i)",
    Fullscreen: "Fullscreen (f)",
    Mute: "Mute (m)",
    Next: "Next (n)",
    "Non-Fullscreen": "Exit Fullscreen (esc)",
    Pause: "Pause (k)",
    Play: "Play (k)",
    "Playback Settings": "Playback Settings",
    Replay: "Replay (k)",
    "Seek backward 10 seconds": "Seek backward 10 seconds (left arrow)",
    "Seek forward 10 seconds": "Seek forward 10 seconds (right arrow)",
    Unmute: "Unmute (m)"
  },
  settings_menu: {
    normal: "Normal",
    off: "Off",
    playback_speed: "Playback Speed",
    send_feedback: "Laporkan Masalah",
    settings: "Pengaturan",
    subtitle: "Subtitle",
    video_quality: "Kualitas Video"
  }
};
export default locale;
